import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * 合并Tailwind CSS类名的工具函数
 *
 * 用于shadcn/ui组件，智能合并和去重类名
 *
 * @param inputs - 类名数组或条件类名
 * @returns 合并后的类名字符串
 *
 * @example
 * cn('px-2 py-1', 'px-3') // => 'py-1 px-3' (后者覆盖前者)
 * cn('text-red-500', condition && 'text-blue-500') // 条件类名
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
